import { createApp } from 'vue'
import App from './App.vue'

const app = createApp(App)
app.provide('appName', import.meta.env.VITE_APP_TITLE)

import PreloadErrorReload from '@/plugins/preloadErrorReload'
app.use(PreloadErrorReload)

import HandleErrors from '@/plugins/handleErrors'
app.use(HandleErrors)

import { createPinia } from 'pinia'
app.use(createPinia())

import { i18n } from '@/plugins/i18n'
app.use(i18n)

import dayjs from '@/plugins/dayjs'
app.use(dayjs)

import { createHead } from '@unhead/vue/client'
app.use(createHead())

import router from './router'
app.use(router)

import { createRouterScroller } from 'vue-router-better-scroller'
app.use(
  createRouterScroller({
    selectors: {
      window: true,
      body: true,
      '#document-view': async ({ to, savedPosition }) => {
        to.meta.scrollPosition = savedPosition
      }
    }
  })
)

import AiPrefetch from '@/plugins/aiPrefetch'
app.use(AiPrefetch)

app.mount('#app')

import { trackAppLoaded } from '@/lib/track'
trackAppLoaded()
